import { StatsHistoryPage } from '../stats-history';
import { StatsSubScreen } from './StatsSubScreen';

/**
 * Прежний раздел меню «Авто-отчёты»: история ежедневных сборов и демография
 * подписчиков. Стал подэкраном «Статистики» — данные смотрят разбирая аномалии,
 * а не каждый день.
 */
export function StatsHistoryScreen(): JSX.Element {
  return (
    <StatsSubScreen
      title="История сборов"
      description="Ежедневные снимки метрик и демография подписчиков по аккаунтам"
    >
      <StatsHistoryPage />
    </StatsSubScreen>
  );
}
